import $ from 'jquery';

const $window = $(window);
const $content = $('.page__content');

triggerResizeEvents();
triggerWheelEvents();

$(function () {
    triggerScrollEvents();
});

function triggerResizeEvents() {
    const prevWinSize = {
        height: $window.height(),
        width: $window.width(),
    };

    $window.on('resize', function () {
        const nextWinSize = {
            height: $window.height(),
            width: $window.width(),
        };

        if (nextWinSize.height !== prevWinSize.height) {
            $window.trigger('resize:height');
        }
        if (nextWinSize.width !== prevWinSize.width) {
            $window.trigger('resize:width');
        }

        [prevWinSize.height, prevWinSize.width] = [nextWinSize.height, nextWinSize.width];
    });
}

function triggerWheelEvents() {
    $window.on('wheel', function (event) {
        if (event.originalEvent.deltaY !== 0) {
            if (event.originalEvent.deltaY < 0) {
                $window.trigger('wheel:up');
            } else {
                $window.trigger('wheel:down');
            }
        }
    });
}

function triggerScrollEvents() {
    let prevScrollTop = 0;

    $content.on('scroll', function () {
        let nextScrollTop = $(this).scrollTop();

        if (nextScrollTop > prevScrollTop) {
            $window.trigger('scroll:down');
        } else {
            $window.trigger('scroll:up');
        }

        prevScrollTop = nextScrollTop;
    });
}
